import script from "./UploaderManyMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./UploaderManyMedia.vue?vue&type=script&setup=true&lang=js"

import "./UploaderManyMedia.vue?vue&type=style&index=0&id=3c69346e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c69346e"]])

export default __exports__